export default __webpack_public_path__ + "static/media/2_Intro.dc17d49c.mp4";